import * as React from 'react';
import {
  DataGrid,
  GridFilterModel,
  GridPaginationModel,
  GridRowParams,
  GridSortModel
} from '@mui/x-data-grid';
import { Stack, styled } from '@mui/material';

export type HeaderTableProps = {
  field: string;
  headerName?: string;
  width?: number;
  sortable?: boolean;
  filterable?: boolean;
};

type DataTableProps = {
  header: HeaderTableProps[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  handleRowClick?: (params: GridRowParams) => void;
  paginationModel: GridPaginationModel;
  handlePaginationModelChange: (newPaginationModel: GridPaginationModel) => void;
  totalRows: number;
  loading?: boolean;
  pageSizeOptions?: number[];
  maxHeight?: number | string;
  height?: number | string;
  onSortModelChange?: (model: GridSortModel) => void;
  sortModel?: GridSortModel;
  onFilterModelChange?: (model: GridFilterModel) => void;
  filterModel?: GridFilterModel;
  isFilter?: boolean;
  isSort?: boolean;
};
export const DataTable = ({
  data,
  header,
  handleRowClick,
  totalRows,
  handlePaginationModelChange,
  paginationModel,
  loading,
  height = 780,
  maxHeight = 780,
  pageSizeOptions,
  onSortModelChange,
  sortModel,
  onFilterModelChange,
  isFilter,
  isSort,
  filterModel
}: DataTableProps) => {
  return (
    <Stack style={{ height, maxHeight, width: '100%' }}>
      <StyledGrid
        getRowId={(row) => row?.leadId || row?.id}
        pageSizeOptions={pageSizeOptions || [10]}
        rows={data}
        columns={header}
        onRowClick={handleRowClick}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        rowCount={totalRows}
        paginationMode="server"
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        filterMode="server"
        filterModel={filterModel}
        onFilterModelChange={(model) => {
          const normalizedModel = {
            ...model,
            items: model.items.map((item) => ({
              ...item,
              operatorValue: 'isAnyOf'
            }))
          };
          onFilterModelChange?.(normalizedModel);
        }}
        loading={loading}
        checkboxSelection
        disableAutosize
        disableColumnFilter={!isFilter}
        disableColumnSelector
        disableColumnMenu={!isFilter && !isSort}
        disableColumnSorting={!isSort}
        disableDensitySelector
      />
    </Stack>
  );
};

const StyledGrid = styled(DataGrid)(() => ({
  '.MuiDataGrid-columnHeaderCheckbox': {
    display: 'none'
  },
  '.MuiDataGrid-cellCheckbox': {
    display: 'none'
  },
  '.MuiDataGrid-row': {
    ' &:nth-of-type(odd)': {
      backgroundColor: '#F1F1E8',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: ' #F1F1E8',
        opacity: 0.8
      }
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: ' #fff',
      opacity: 0.8
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    },
    '.MuiDataGrid-cell': {
      outline: 'none'
    }
  },
  '.MuiDataGrid-selectedRowCount': {
    visibility: 'hidden'
  },
  '.MuiDataGrid-columnHeader:focus': {
    outline: 'none'
  },
  '.Mui-selected': {
    ' &:nth-of-type(odd)': {
      backgroundColor: 'rgba(34, 55, 74, 0.08)'
    }
  }
}));
